import { css } from 'lit';

/*
This file is reserved for any custom css that developers want to add to
customize their theme. Simply add your css to this file and yarn build.
*/

export default css`
  #link-operations-top {
    display: none;
  }
  .m-markdown pre {
    min-height: 50px;
  }
  .m-table {
    border: none;
  }
  .api-key-input {
    width: 60%;
  }
  .request-body-param-user-input {
    background-color: #252937;
    color: #F3F3F4;
    border: none;
  }
  .min-width-200 {
    min-width: 200px;
  }
  .mb-30 {
    margin-bottom: 30px;
  }
  .d-none {
    display: none;
  }
  .loading {
    pointer-events: none;
    opacity: 0.5;
  }
  .buttons-row {
    display:flex;
    align-items: center;
    flex-direction: column;
  }
  .buttons-row .m-btn {
    min-width: 292px;
  }
  .buttons-row .m-btn:not(:last-child) {
    margin-bottom: 5px;
  }
  
  @media only screen and (min-width: 768px) {
      .buttons-row {
        flex-direction: row;
        justify-content: flex-end;
      }
      .buttons-row .m-btn:not(:last-child) {
        min-width: auto;
        margin-right: 5px;
        margin-bottom: 0;
      }
      .buttons-row .m-btn:last-child {
        min-width: 200px;
      }
  }
`;
